import Duolist from './Duolist';
export * from './Duolist';
export default Duolist;
